module.exports = __webpack_public_path__ + "static/social-media-desktop-9d574fb3ef2103701f3b5fdf519b29c6.webp";